import React from "react";
import clsx from "clsx";
import { Dialog, DialogContent, useMediaQuery, useTheme } from "@mui/material";
import { Box } from '@curves/ui-base';
import { SecondaryColorHeader } from "@Local/Components";
import MeasureTrendAreaChart from "@Local/Dashboard/MeasureTrendAreaChart";
import useDialogSlideTransition from "@Util/hook/useDialogSlideTransition";

const TrendAreaChartDialog = props => {
	const { className, open, sourceData = {}, onClose } = props;
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const Transition = useDialogSlideTransition("up");
	const chartSourceData = sourceData || {};

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	return (
		<Dialog className={clsx(className)} open={open} fullScreen={fullScreen} fullWidth TransitionComponent={Transition} PaperProps={{ style: { minHeight: "100vh" } }}>
			<SecondaryColorHeader onClose={handleClose} direction="up">量身歷史趨勢</SecondaryColorHeader>
			<DialogContent style={{ padding: 0, height: "100vh" }}>
				<Box style={{ height: "100%" }}>
					<MeasureTrendAreaChart sourceData={chartSourceData} />
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default TrendAreaChartDialog;
